import {
  ColorSchemeProvider,
  DEFAULT_COLOR_SCHEME,
} from 'redesignedComponents/context/colorScheme';
import { WithColorSchemeProps } from './types';

function withColorScheme<T>(Component) {
  return function HOC({
    colorScheme = DEFAULT_COLOR_SCHEME,
    ...restProps
  }: WithColorSchemeProps<T>) {
    return (
      <ColorSchemeProvider value={colorScheme}>
        <Component {...restProps} />
      </ColorSchemeProvider>
    );
  };
}

export default withColorScheme;
